import React from 'react'
import { Form, Loader, Message } from 'semantic-ui-react'
import 'semantic-ui-css/components/message.css'
import 'semantic-ui-css/components/loader.css'
import 'semantic-ui-css/components/form.css'
import { actions } from 'react-redux-form'
import { withRouter } from 'react-router-dom'
import { get, each } from 'lodash'
import ErrorBoundary from '@oldscope/error-handling/ErrorBoundaryHOC'
import { func } from 'prop-types'
import MyForm from './_Form'
import { credentials } from '../../ContentfulClient'
import Field from './_Field'

require('whatwg-fetch')

@withRouter
@ErrorBoundary
class ContactForm extends React.Component {
  static childContextTypes = {
    refreshDefaultContactID: func,
  }

  getChildContext = () => ({
    refreshDefaultContactID: loadedOptions => {
      const contactIDParam = this.getContactID()
      if (contactIDParam)
        each(loadedOptions, opt => {
          if (opt.indexOf(contactIDParam) > -1)
            this.formDispatch(actions.change('contact.contactID', opt))
        })
    },
  })

  state = {
    submitted: false,
    submitting: false,
    error: null,
  }

  attachDispatch = dispatch => {
    this.formDispatch = dispatch
  }

  handleChange = values => {}

  handleUpdate = form => {}

  componentDidUpdate = (prevProps, prevState) => {
    if (!prevState.error && this.state.error) {
      throw new Error(this.state.error)
    }
  }

  handleSubmit = values => {
    this.setState({ submitting: true })
    this.formDispatch(
      actions.submit(
        'contact',
        fetch(
          'https://ut3avtrnfc.execute-api.us-east-1.amazonaws.com/default/ContactForm',
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              ...values,
              spaceID: credentials.space,
            }),
          },
        )
          .then(resp => resp.json())
          .then(data => {
            if (!data.success) {
              this.setState({
                submitting: false,
                error: (data && data.errorMessage) || 'Unknown Error',
              })
            } else {
              this.setState({ submitted: true, submitting: false })
              this.formDispatch(actions.reset('contact'))
              return true
            }
          }),
      ),
    )
  }

  showForm = e => {
    e.preventDefault()
    this.setState({ submitted: false })
  }

  getContactID = props => {
    const { match, contactID } = props || this.props
    return contactID || get(match, 'params.contactID') || ''
  }

  render() {
    const { submitted, submitting } = this.state
    const { ContactInputComponent } = this.props

    if (submitted)
      return (
        <Message
          success
          icon="checkmark"
          header="Thank you!"
          content={
            <span>
              Your information has been submitted, and we will respond as soon
              as we can.
              <br />
              <a onClick={this.showForm} href="#showcontactform">
                Click here if you would like to send another message.
              </a>
            </span>
          }
        />
      )
    if (submitting) return <Loader inline active />
    return (
        <MyForm
          model="contact"
          onUpdate={this.handleUpdate}
          onChange={this.handleChange}
          onSubmit={this.handleSubmit}
          getDispatch={this.attachDispatch}
          initialState={{
            contactID: this.getContactID()
              ? `contact.id_${this.getContactID()}`
              : 'contact.name_cpcdenomination',
          }}
        >
          {ContactInputComponent && <ContactInputComponent />}
          <Field model=".name" required />
          <Form.Group widths="equal">
            <Field type="email" model=".email" required />
            <Field model=".phone" />
          </Form.Group>
          <Field model=".subject" required />
          <Field type="textarea" model=".message" required />
        </MyForm>
      )
  }
}

export default ContactForm
